import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { PaymentRequestFilter } from 'app/shared/filters/payment-request.filter';
import { CompanyBase } from 'app/shared/models/company-base.model';
import { PaymentRequestStatus } from 'app/shared/models/payment-request-status.model';
import { PaymentRequest } from 'app/shared/models/payment-request.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';
import { SectionService } from 'app/shared/services/section.service';
import { PaginationService } from 'ngx-pagination';
import { format } from 'util';
import { PaymentRequestUrlComponent } from '../payment-request-url/payment-request-url.component';

@Component({
  selector: 'app-payment-requests-list',
  templateUrl: './payment-requests-list.component.html',
  styleUrls: ['./payment-requests-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class PaymentRequestsListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {
      name: 'IsExpired',
      displayName: 'paymentRequests.isExpiredFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {
      name: 'PaymentRequestId',
      displayName: 'paymentRequests.paymentRequestIdFieldTitle',
      canSort: true,
      displayClass: "d-none d-lg-table-cell"
    },
    {
      name: 'CreatedAt',
      displayName: 'paymentRequests.createdAtFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {
      name: 'RemittanceInformation',
      displayName: 'paymentRequests.remittanceInformationFieldTitle',
      canSort: true,
      displayClass: ""
    },
    {name: 'Amount', displayName: 'paymentRequests.amountFieldTitle', canSort: true, displayClass: ""},
    {name: 'ExpirationDate', displayName: 'paymentRequests.expirationDateFieldTitle', canSort: false, displayClass: ""},
    {
      name: 'CompletedAt',
      displayName: 'paymentRequests.completedAtFieldTitle',
      canSort: true,
      displayClass: "d-none d-lg-table-cell"
    },
    {
      name: 'Company.Name',
      displayName: 'paymentRequests.companyNameFieldTitle',
      canSort: false,
      displayClass: "d-none d-xl-table-cell"
    },
  ];

  paymentRequestFilter: PaymentRequestFilter;
  statusesUpdatedSuccessfullyMessage: string;

  get companySelectionListClass(): string {
    if (this.hasSelectCompanyPermission) {
      return "d-none d-xl-block selection-list";
    }

    return "";
  }

  get hasSelectCompanyPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequests_SelectCompany);
  }

  get hasToggleUpgradeCreditPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequests_ToggleUpgradeCredit);
  }

  constructor(protected sectionService: SectionService, protected paymentRequestService: PaymentRequestService, protected translateService: TranslateService, protected modalService: NgbModal) {
    super(sectionService, Sections.PaymentRequests, modalService, Modals.PaymentRequestComponent);
  }

  ngOnInit() {
    this.paymentRequestFilter = new PaymentRequestFilter();
    super.initializeView(Constants.PaymentRequests_List_DefaultSortField, Constants.PaymentRequests_List_DefaultSortDirectionAscending);
    this.translateService.get(['paymentRequests.statusesUpdatedSuccessfullyMessage'])
      .subscribe(translations => {
        this.statusesUpdatedSuccessfullyMessage = translations['paymentRequests.statusesUpdatedSuccessfullyMessage'];
      });
  }

  searchFilter(event: any) {
    this.paymentRequestFilter.RemittanceInformation = event.target.value.toLowerCase();
    this.getCollection();
  }

  handleCompanyChanged(company: CompanyBase) {
    if (company) {
      this.paymentRequestFilter.CompanyId = company.CompanyId;
    } else {
      this.paymentRequestFilter.CompanyId = undefined;
    }

    this.getCollection(Constants.DefaultPageNumber);
  }

  handlePaymentRequestStatusChanged(paymentRequestStatus: PaymentRequestStatus) {
    if (paymentRequestStatus) {
      this.paymentRequestFilter.StatusCode = paymentRequestStatus.Code;
    } else {
      this.paymentRequestFilter.StatusCode = undefined;
    }

    this.getCollection();
  }

  handleBooleanToggleFilterChanged(newValue: boolean) {
    this.paymentRequestFilter.IsUpgradeCreditRequest = newValue;
    this.getCollection();
  }

  updateStatuses() {
    this.paymentRequestService.updateStatuses((this.collection as PaymentRequest[]).map(pr => pr.PaymentRequestId), () => this.getCollection(null), this.statusesUpdatedSuccessfullyMessage);
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.paymentRequestService.getCollectionPaginated<PaymentRequest>("/payment-request", this.pageConfiguration, this.paymentRequestFilter, (collection) => {
      this.collection = collection
    });
  }
}
